module.exports = __webpack_public_path__ + "static/media/waitListPoPUPScreen.116bf335.png";